module.exports = __webpack_public_path__ + "static/media/screen8.612f11db.png";